export default "__VITE_ASSET__BLNNasia__"